import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from './utils/api'
import colors from './common/js/color'
import VueAMap from 'vue-amap';
import * as common from './common/js/common.js'
import BaiduMap from 'vue-baidu-map'
import './common/css/element-variables.scss'

Vue.use(VueAMap);
Vue.use(ElementUI);
Vue.use(colors);

Vue.config.productionTip = false

// 在Vue实例中添加$message属性
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$api = api;
Vue.prototype.$common = common;

// 初始化vue-amap
VueAMap.initAMapApiLoader({
    // 高德的key
    key: '69e5c9e21c05a2df01038460e2bc193b',
    // 插件集合
    plugin: ['AMap.Autocomplete',
        'AMap.PlaceSearch',
        'AMap.Scale',
        'AMap.OverView',
        'AMap.ToolBar',
        'AMap.MapType',
        'AMap.PolyEditor',
        'AMap.CircleEditor',
        'AMap.Geolocation'
    ],
    // 高德 sdk 版本，默认为 1.4.4
    v: '1.4.4'
});

// 初始化百度地体
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'b43XBgYUeqK8lkpEqmV3v29WVr3LO7MG'
})


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
//#app，id选择器，唯一的
